<script>
import Vue from 'vue'
import { MODAL } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import ChatView from '@modules/aawz-intelligence-v2/views/chat/view-chat.vue'

export default {
  components: { ChatView },
  data() {
    return {
      busModal: new Vue(),
    }
  },
  created() {
    GlobalBus.$on(MODAL.GLOBAL_GLOBAL_CHAT_IA, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.GLOBAL_GLOBAL_CHAT_IA, this.open)
  },
  methods: {
    // No-op de propósito: este modal não tem estado local para limpar — o chat
    // de tela cheia lê a conversa ATIVA do store. O `clear()` fica porque o
    // gate do design-system o exige de qualquer arquivo em `modal/`, e cumprir a
    // regra em 2 linhas é mais barato que abrir exceção com allowlist.
    clear() {},
    // Sem payload: o chat de tela cheia é sempre a conversa ATIVA do store, não
    // uma conversa passada por quem abriu. O `item` que existia aqui era copiado
    // e nunca lido.
    open() {
      this.clear()
      this.busModal.$emit('dialog', true)
    },
    // `withoutCloseButton` desliga o X do BaseModal (ele mora numa linha de
    // titulo que empurraria o chat para baixo), entao o fechar e nosso — e o
    // contrato do BaseModal para isso e o mesmo bus do open.
    fechar() {
      this.busModal.$emit('dialog', false)
    },
  },
}
</script>

<template>
  <!-- Tela cheia = o chat e a tela inteira. Sem titulo (o proprio chat ja diz
       o que e), sem padding do card e sem a linha de titulo do BaseModal: os
       tres so roubavam area do layout fundido. O X vira um botao flutuante
       sobre o conteudo, no canto direito. -->
  <BaseModal
    :bus="busModal"
    persistent
    maxWidth="90%"
    withoutCloseButton
    paddingOverride="0"
    titleRowPaddingOverride="0"
  >
    <!-- Sem `embedded`: e ele que desliga o `usaLayoutFundido`, e com o layout
         fundido desligado o modal recebia o desenho ANTIGO — sem superficie
         quente, sem sidebar fundida, sem heroi a esquerda. "Tela cheia" que
         mostra menos que o popup nao faz sentido. A altura e explicita porque
         o card do BaseModal e `display: block`: ele nao estica o filho, e sem
         teto a coluna de mensagens cresceria sem limite dentro do modal. -->
    <div class="global-modal-chat-ia__corpo">
      <ChatView />
      <v-btn
        icon
        class="global-modal-chat-ia__fechar"
        aria-label="Fechar"
        @click="fechar"
      >
        <icon-svg name="close-circle" color="var(--muted)" :size="30" />
      </v-btn>
    </div>
  </BaseModal>
</template>

<style lang="sass" scoped>
// Sem titulo e sem padding, a moldura do modal virou zero — o chat ocupa a
// altura inteira. (`min-height: 100vh` no card vem de `cardMinHeight` em
// `_base-modal.vue`; a altura aqui e o que de fato dimensiona o filho, ja que
// o card e `display: block` e nao estica ninguem.)
.global-modal-chat-ia__corpo
  position: relative
  height: 100vh

// Flutua sobre o conteudo em vez de ocupar uma faixa propria. Fica na coluna
// de conversa (a direita da sidebar), alinhado com o topo do chat.
.global-modal-chat-ia__fechar
  position: absolute
  top: 8px
  right: 12px
  z-index: 2
</style>
